module.exports = __webpack_public_path__ + "img/quizmayhem_banner_science.0818273f.jpg";